import React, { useState } from "react";
import "./Model-Style/modal.css";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import {} from "../../../../Redux/Actions/actions";
import { MdModeEditOutline } from "react-icons/md";
import FormControl from "@mui/material/FormControl";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
} from "@mui/material";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toaststyle } from "../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    externalChatData: state.contactListData.externalChatData,
  };
};

const WhatsappModal = (props) => {
  const { close, OpenDialog, handleClose } = props;
  const [phonenumber, setPhonenumber] = useState(
    props.externalChatData.phonenumber
  );
  const [phonenumbervalidation, setPhonenumbervalidation] = useState(false);

  const handleTransferWhatsapp = async () => {
    const access_token = localStorage.getItem("access_token");
    try {
      const data = await axios.post(
        BaseUrl + "/users/transfertoWhatsapp",
        {
          chat_session_id: props.externalChatData.chat_session_id,
          phonenumber: phonenumber,
        },
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      let message_to_pass;
      if (data.data.status) {
        let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));
        await axios.post(
          BaseUrl + "/message/addMessage",
          {
            from: old_agent_id.id,
            to: props.externalChatData.id,
            message: message_to_pass,
            senderName: old_agent_id.username,
            receiverName: props.externalChatData.username,
            messageFrom: "fromAgent",
            userType: props.externalChatData.chat_type,
            session: props.externalChatData.chat_session_id,
            msg_sent_type: "NOTIFICATIONS",
          },
          {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        );
        setPhonenumbervalidation(false);
        toast.success("Chat Transferred to whatsapp sucessfully", toaststyle);
        setPhonenumber("");
      } else {
        setPhonenumbervalidation(true);
        toast.error("Enter a Valid Number", toaststyle);
        setPhonenumber("");
      }
    } catch (error) {
      toast.warn("Something Went Wrong", toaststyle);
      setTimeout(() => {
        close();
      }, 1000);
    }
  };

  console.log("props.externalChatData", props.externalChatData);
  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& .MuiPaper-root": {
          padding: 1,
          top: -100,
        },

        backgroundColor: "rgb(0 0 0 / 15%)",
      }}
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "16px", fontWeight: 600 }}
      >
        Transfer To WhatsApp
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack>
            <Stack direction={"row"}>
              <FormControl
                sx={{ m: 1, minWidth: 170 }}
                size="small"
              ></FormControl>
              <FormControl
                sx={{ m: 1, minWidth: 180 }}
                size="small"
              ></FormControl>
            </Stack>
            <input
              className="form-control"
              type="text"
              placeholder="Type phone number"
              value={phonenumber}
              onChange={(e) =>
                setPhonenumber(e.target.value.replace(/[^\d]/, ""))
              }
            ></input>
            <Tooltip title="Edit Number">
              <MdModeEditOutline size={20} className="whatsappEdit-icon" />
            </Tooltip>
            {phonenumbervalidation ? (
              <span
                className="text-danger fw-bold"
                style={{ fontSize: "10px" }}
              >
                Please fill in the phone number field*
              </span>
            ) : (
              ""
            )}
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (phonenumber === "") {
              setPhonenumbervalidation(true);
            } else {
              setPhonenumbervalidation(false);
              handleTransferWhatsapp();
              // handleClose()
            }
          }}
          size="sm"
          className="mb-2 float-end"
          variant="contained"
          endIcon={<PaperPlaneTilt size={15} />}
        >
          Transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {})(WhatsappModal);
